exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable-blocks[data-v-3d490f52]{padding:14px}.sortable-blocks>div[data-v-3d490f52]{margin:0 10px 10px 0;float:left}.ui-sortable-placeholder[data-v-3d490f52]{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d490f52","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/Projects.vue
// module id = 712
// module chunks = 1